import { companyAPI, userAPI } from '@/services-ts/axios'
import type { IPermission } from '@/types/Data'
import type { IDataStore } from '@/types/Store/State'
import { defineStore } from 'pinia'

// Modül-scope: iki bağımsız giriş noktası (router guard + DefaultLayout) aynı
// in-flight isteği paylaşsın diye store state'inin dışında tutuluyor.
let permissionRequest: Promise<IPermission[]> | null = null

export const useDataStore = defineStore('data', {
  state: (): IDataStore => ({
    companyInfo: {
      id: '',
      name: '',
      isDefaultColor: false,
      colorHeader: '',
      colorHeaderText: '',
      colorBrand: '',
      logoUrl: '',
      bannerUrl: '',
      inactiveImageUrl: '',
      backgroundImageUrl: '',
      pushLogoImageUrl: '',
      isHidePostPoint: false,
      isJobAniversaryHide: false,
      isBirthdayHide: false,
      launchDate: '',
      mobileIconName: '',
      celebrationRange: 1,
      jobStartRange: 1,
      companyCode: '',
      timeZone: null,
      isActive: false,
      isDeleted: false,
      createdAt: null,
      domain: null,
      currencyName: null,
      exchangeRate: null,
      totalNumberOfUser: null,
      totalNumberOfActiveUser: null,
      publicPostDescriptionText: null,
      publicPostButtonName1: null,
      publicPostButtonLink1: null,
      publicPostButtonName2: null,
      publicPostButtonLink2: null,
      publicPostCompanyLogoUrl: null,
      hasSmsProvider: false,
      taxNumber: null,
      taxOffice: null,
      isMFAActive: false,
      isMFAEmail: false,
      isMFASMS: false,
      isSecurlyPassword: false,
      restrictUsernameinPassword: false,
      isRequiredUppercaseLowercase: false,
      isRequiredSpecialChar: false,
      maxCharinPassword: null,
      passwordRenewTimeMonth: null,
      notificationSenderName: null,
      backgroundMode: 'Mini',
      fourWeekImageUrl: null,
      mobileMenuImageUrl: null,
      mobileBannerImageUrl: null,
    },
    permissionList: [],
  }),

  actions: {
    async GetCompanyInfo() {
      const { data, status } = await companyAPI.CompanyServices.GetCompanyInfo()
      if (status) this.companyInfo = data
    },

    async GetPermissionByJwt() {
      // Router guard (checkPermissions) ve DefaultLayout onMounted ilk yüklemede bu
      // action'ı üst üste çağırıyor; korumasızken Role/GetPermissionByJwt 2 kez
      // atılıyordu. WebNew'de (src/stores/data.ts getPermissionByJwt) aynı sorun
      // in-flight dedupe + sonuç cache ile çözülmüştü; pattern buraya uyarlandı.
      if (this.permissionList.length > 0) return this.permissionList
      if (permissionRequest) return permissionRequest

      permissionRequest = (async () => {
        const { data, status } = await userAPI.RoleServices.GetPermissionByJwt()

        // Başarısız istek cache'lenmez: liste boş kaldığı için sonraki çağrı yeniden dener.
        if (status) this.permissionList = data

        return this.permissionList
      })()

      try {
        return await permissionRequest
      } finally {
        permissionRequest = null
      }
    },

    async GetFlattenList(Reload: boolean = false) {
      if (this.getPermissionList.length === 0 && Reload) await this.GetPermissionByJwt()
      return this.getPermissionList
    },
  },

  getters: {
    getPermissionList() {
      const list: string[] = []
      getAllKeys(this.permissionList, list)
      return list
    },
  },
})

const getAllKeys = (arr: IPermission[], list: string[]) => {
  arr.forEach(item => {
    list.push(item.key)
    if (item.permissions) {
      getAllKeys(item.permissions, list)
    }
  })
}
